module.exports = __webpack_public_path__ + "static/media/sort-numeric-up.44315bd6.svg";